import _ from 'lodash';

export const formatCurrency = (priceToFormat: string) => {
    const price = parseFloat(priceToFormat);

    if (_.isNaN(price)) {
        return '';
    }

    return price.toFixed(2);
};

export const formatNumberToPrecision = (numberToFormat?: string | number, desiredPrecision = 2) => {
    const newNumber = _.isString(numberToFormat) ? parseFloat(numberToFormat) : numberToFormat;

    if (_.isNaN(newNumber) || newNumber == null) {
        return 0;
    }
    return Number(newNumber.toFixed(desiredPrecision));
};
